/** Phase 3 message files, one per task so parallel builders never share a file (docs/PHASE-3-PLAN.md). */
import { archEnGB } from './arch.js';
import { c4EnGB } from './c4.js';
import { l3EnGB } from './l3.js';
import { s21EnGB } from './s21.js';
import { s22EnGB } from './s22.js';
import { s23EnGB } from './s23.js';
import { s24EnGB } from './s24.js';
import { s25EnGB } from './s25.js';
import { s26EnGB } from './s26.js';
import { s27EnGB } from './s27.js';
import { s28EnGB } from './s28.js';
import { s28bEnGB } from './s28b.js';
import { s29EnGB } from './s29.js';
import { s30EnGB } from './s30.js';
import { s31EnGB } from './s31.js';
import { s32EnGB } from './s32.js';
import { s33EnGB } from './s33.js';
import { s34EnGB } from './s34.js';
import { s35EnGB } from './s35.js';
import { s36EnGB } from './s36.js';
import { w16EnGB } from './w16.js';
import { w17EnGB } from './w17.js';
import { w18EnGB } from './w18.js';
import { w19EnGB } from './w19.js';
import { w20EnGB } from './w20.js';
import { w21EnGB } from './w21.js';
import { w22EnGB } from './w22.js';
import { w23EnGB } from './w23.js';
import { k6EnGB } from './k6.js';
import { k7EnGB } from './k7.js';
import { m4EnGB } from './m4.js';
import { m5EnGB } from './m5.js';
import { m6EnGB } from './m6.js';
export const phase3EnGB = {
    ...archEnGB,
    ...c4EnGB,
    ...l3EnGB,
    ...s21EnGB,
    ...s22EnGB,
    ...s23EnGB,
    ...s24EnGB,
    ...s25EnGB,
    ...s26EnGB,
    ...s27EnGB,
    ...s28EnGB,
    ...s28bEnGB,
    ...s29EnGB,
    ...s30EnGB,
    ...s31EnGB,
    ...s32EnGB,
    ...s33EnGB,
    ...s34EnGB,
    ...s35EnGB,
    ...s36EnGB,
    ...w16EnGB,
    ...w17EnGB,
    ...w18EnGB,
    ...w19EnGB,
    ...w20EnGB,
    ...w21EnGB,
    ...w22EnGB,
    ...w23EnGB,
    ...k6EnGB,
    ...k7EnGB,
    ...m4EnGB,
    ...m5EnGB,
    ...m6EnGB,
};
//# sourceMappingURL=index.js.map